module.exports = __webpack_public_path__ + "img/bornutti14.2b3ac713.jpg";